<template>
  <div class="toDoStatistics">
    <my-head :title="title"/>
    <mu-data-table :loading="isloading" stripe fit :columns="columns" :sort.sync="sort" @sort-change="handleSortChange" @row-click="goInfo" :data="list">
      <template slot-scope="scope">
        <td>{{scope.row.BusinessTypeName}}</td>
        <td>{{scope.row.count}}</td>
      </template>
    </mu-data-table>

  </div>
</template>

<script>
import myHead from '@/components/header'
import api from "@/common/api"
import scanning from "@/components/scanning"
export default {
  name: 'pickcar',
  components: {
    myHead, scanning
  },
  data () {
    return {
      title: "待办统计",
      scanMark: "",
      tableLoading: false,
      isScanning: false,
      isloading: true,
      openFullscreen: false,
      deleteIndex: null, // 删除第几张
      openAlert: false, // 删除图片层
      src: [], // 拍照的图片
      files: [], // 图片文件 base64
      showDetailedDialog: false,
      expandIndex: -1, // 当前选择行
      bigImg: null,
      otherTaskTo: false,
      requestOnce: true,
      form: {
        vin: "",
        orderNumber: "",
        checkbox: [],
        text: ""
      },
      options: ['正常', '异常'],
      sort: {
        name: '',
        order: 'asc'
      },
      columns: [
        { title: '任务类型', name: 'name' },
        { title: '数量', name: 'calories', width: 150, align: 'left'}
      ],
      list: [
        {
          name: '检查电池电压',
          editType: 1,
          flagxxxx: "",
          lv:"",
          hv:"",
          leftBefore: "",
          rightBefore: "",
          leftAfter: "",
          rightAfter: "",
          remarks: ""
        },
        {
          name: '检查胎压',
          editType: 2,
          flagxxxx: "",
          lv:"",
          hv:"",
          leftBefore: "",
          rightBefore: "",
          leftAfter: "",
          rightAfter: "",
          remarks: ""
        },
        {
          name: '检查车身',
          editType: 3,
          flagxxxx: "",
          lv:"",
          hv:"",
          leftBefore: "",
          rightBefore: "",
          leftAfter: "",
          rightAfter: "",
          remarks: ""
        }
      ]
    }
  },
  methods: {
    goInfo(index, row, event){
      window.localStorage.setItem("toDoStatisticsList", JSON.stringify(row));
      this.$router.push({name: 'toDoStatisticsList', params:{ row: row}});
    },
    queryData(){
      this.Toast.loading({message: '查询中'});
      this.isloading = true;
      let data = Object.assign({},this.$store.state.user,{
        content: {
        }
      });
      /* 发送post请求 */
      if(this.requestOnce){
        this.common.reqData(api.app('waitingProcessingQueryAll'), data, res=>{
          this.requestOnce = true;
          this.isloading = false;
          this.Toast.clear();
          console.log("返回数据：", res.data)
          if(res.data.status == 100){
            this.list = res.data.content.datas || [];
          }else{
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            });
          }
        },err =>{
          this.requestOnce = true;
          this.isloading = false;
          this.Toast.clear();
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          });
          console.log(err)
        });
      }
    },
    changeAbnormal(val, index){
      val == "异常" ? this.expandIndex = index : this.expandIndex = -1;
    },
    rowClick(index,row,event){
      row.flagxxxx == "异常" ? this.expandIndex = index : this.expandIndex = -1;
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    hideDetailed(){
      this.showDetailedDialog = false;
    },
    showDetailed(){
      this.showDetailedDialog = true;
    },
    openFullscreenDialog (index) {
      this.bigImg = this.src[index];
      this.openFullscreen = true;
    },
    closeFullscreenDialog () {
      this.openFullscreen = false;
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    changeCheckBox(v){
      console.log(this.form.checkbox)
    },
    deleteImgDialog (index) {
      // 删除图片 打开
      this.deleteIndex = index;
      this.openAlert = true;
    },
    closeAlertDialog (state) {
      // 删除图片 关闭
      if(state === 'y'){
          this.src.splice(this.deleteIndex, 1);
          this.files.splice(this.deleteIndex, 1);
      }
      this.openAlert = false;
    },
    
    paizhao(){
      let _this = this;
      if(window.plus){
        var cmr = plus.camera.getCamera();
        var res = cmr.supportedImageResolutions[0];
        var fmt = cmr.supportedImageFormats[0];
        console.log("Resolution: "+res+", Format: "+fmt);
        cmr.captureImage( function( path ){
            plus.io.resolveLocalFileSystemURL( path, function ( entry ) {
                // 转化本地绝对路径
                var url = plus.io.convertLocalFileSystemURL(path);
                _this.src.push("file://"+url);
                // 获取图片对象
                entry.file( function(file){
                    var fileReader = new plus.io.FileReader();
                    fileReader.onloadend = function(evt) {
                        console.log(evt.target.result);
                        _this.files.push(evt.target.result);
                    }
                    fileReader.readAsDataURL(file);
                });
            });
        },
        function( error ) {
            console.log( "拍照已经取消: " + error.message );
        },
        {resolution:res,format:fmt}
        );
      }
    },
    getData (){

    },
    closeing (val) {
      val ? this.isScanning = false : null;
    },
    childByValue (val) {
      if(val){
        if(val.split('&')[1] == 'vin'){
          this.vin = val.split('&')[0];
          this.getData();
        }
      }
    },
    scan (txt) {
      this.scanMark = txt;
      this.isScanning = true;
    },
    closeFullscreenDialog(){
      this.openFullscreen = false;
      this.closeScan();
    },
    scanQR(){
      this.openFullscreen = true;
      let _this = this;
      if (!window.plus) {return;}
      setTimeout(() => {
        scan = new plus.barcode.Barcode('bcid');
        scan.onmarked = onmarked;
        function onmarked(type, result, file) {
          switch (type) {
            case plus.barcode.QR:
              type = 'QR';
              break;
            case plus.barcode.EAN13:
              type = 'EAN13';
              break;
            case plus.barcode.EAN8:
              type = 'EAN8';
              break;
            default:
              type = '其它' + type;
              break;
          }
          result = result.replace(/\n/g, '');
          _this.vin = result;
          _this.closeScan();
        }
      }, 40);
    },
    //开始扫描
    startScan() {
      if (!window.plus) {return;}
      scan.start();
    },
    //关闭
    closeScan() {
      this.openFullscreen = false;
      if (!window.plus) {return;}
      scan.close();
    },
  },
  mounted () {
    this.queryData();
  },
  watch: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auto-width{
  width: 100%;
  max-width: 375px;
  margin: 10px auto;
}
.my-null{
  color: red;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 15px;
  margin-bottom: 2rem;
}
.detailed{
  padding: 15px;
  height: calc(100% - 56px);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto; 
}
.my-card{
  margin-bottom: 2rem;
  padding: 15px;
}
.input{
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
#mytable .mu-input{
  width: 100%;
  margin: 0;
}
.toDoStatistics-btns{
  display: flex;
  width: 85%;
  margin-top: 20px;
  justify-content: space-between;
}
.toDoStatistics-btns button{
  margin: 0 0;
}
.photos{
    border: 1px solid #ccc;
    width: 90%;
    margin: 20px auto 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
i.iconfont.icon-icon25201{
    display: block;
    font-size: 50px;
    margin: 10px;
}
.toDoStatistics-box{
  padding-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/toDoStatistics/toDoStatistics.vue